import React from 'react'
import Footer from "../../footer"

export default function Index(props) {
  // Get guest data from props.cardData
  const guests = props.cardData || [];
  
  return (
    <div className="assessment1-container">
      <div className="assessment1-title">
        Directions
      </div>
      <div className="assessment1-content">
        The guests are seated at their table and have a chance to review the menu.  It's time to announce the specials for tonight. Because you're an experienced waiter, you have no problem articulating the specials and are able to observe each guest's reaction to each special. To impress your love interest, you are tasked with guessing what each guest's favorite, second favorite, and least favorite dish are based on their facial reactions.
      </div>
      
      {/* Display guest images and names if available */}
      {guests.length > 0 && (
        <div style={{ 
          marginTop: '30px',
          marginBottom: '30px'
        }}>
          <div style={{ 
            fontWeight: 'bold', 
            marginBottom: '20px', 
            textAlign: 'center',
            fontSize: '18px'
          }}>
            Tonight's Guests:
          </div>
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            justifyContent: 'center',
            gap: '20px'
          }}>
            {guests.map((guest, index) => (
              <div key={index} style={{ 
                textAlign: 'center',
                width: '120px'
              }}>
                <img 
                  src={guest.img || guest.otherImg} 
                  alt={guest.name}
                  style={{ 
                    width: '100px', 
                    height: '100px', 
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid #f0f0f0',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }}
                />
                <div style={{ 
                  marginTop: '8px', 
                  fontSize: '16px',
                  fontWeight: '600'
                }}>
                  {guest.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="assessment1-wrap">
        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
